import { useRouteMatch } from 'react-router-dom';
import { Redirect, Route } from 'react-router';
import { Switch } from 'react-router-dom';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import { ForumRoutes as Routes } from '../constants/routes';
import TopicsList from './topicsList';
import PostsList from './postsList';
import CreateTopic from './createTopic';
import { IForumService } from '../model/interfaces';
import { container } from 'tsyringe';
import { useAsyncData } from '@utils/hooks';

function ForumRoutes() {
  const { path } = useRouteMatch();
  const forumService: IForumService = container.resolve('forumService');
  const isModer = useAsyncData(() => forumService.getModerating());

  return (
    <Switch>
      <Route exact path={path + '/:threadsName'} component={TopicsList} />
      <Route exact path={path + '/:threadsName/p-:countPage'} component={TopicsList} />
      <Route exact path={path + '/:threadsName/p-:countPage/:topicId'} component={PostsList} />
      <Route path={path + '/:threadsName/create'} component={CreateTopic} />
      <Route path={path + '/:threadsName/:topicId'} component={PostsList} />
      <Redirect from={MAIN_ROUTES.forum} to={path + '/' + Routes.BACKGAMMON} />
    </Switch>
  );
}

export default ForumRoutes;
